/* Prototype motion and interaction. Calm and once only, never looping; prefers-reduced-motion shows everything at once.
   - header: compact shadow after scrolling, "Shop Fitpod" button appears once the hero is passed
   - hero: text rises in, photo settles from a slight zoom (one time)
   - statement: words fade in one after another; [data-stagger]: children follow each other
   - <fitpod-story>: sticky image that changes with the step in view
   - numbers count up once; <fitpod-teaser>: colour switch crossfades the product
   - product: sticky buy bar when the main button is out of view, image lightbox */
(function () {
  var reduce = false;
  try { reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
  document.documentElement.classList.toggle("fp-motion", !reduce);

  function onReady(fn) { if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn); else fn(); }

  onReady(function () {
    var ready = function () { document.body.classList.add("is-ready"); };
    requestAnimationFrame(ready);
    setTimeout(ready, 120); // fallback: text never stays hidden if frames are delayed

    // Header state
    var header = document.querySelector(".fp-header");
    var hero = document.querySelector(".fp-band--hero");
    function onScroll() {
      var y = window.scrollY;
      if (header) header.classList.toggle("is-scrolled", y > 8);
      var past = hero ? y > hero.offsetHeight * 0.6 : y > 360;
      document.body.classList.toggle("is-past-hero", past);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    // Reveal-driven extras: statement words, stagger groups, number count-up
    var io = "IntersectionObserver" in window ? new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add("is-in");
        if (e.target.matches(".fp-numbers")) countUp(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.3 }) : null;
    document.querySelectorAll(".fp-statement--words, [data-stagger]").forEach(function (el) {
      if (io && !reduce) io.observe(el); else { el.classList.add("is-in"); }
    });

    function countUp(list) {
      if (reduce) return;
      list.querySelectorAll("[data-count]").forEach(function (el) {
        var target = el.dataset.count, n = parseInt(target, 10), suffix = target.replace(/^\d+/, "");
        if (!n || n < 2) return;
        var t0 = performance.now(), dur = 900;
        (function frame(now) {
          var k = Math.min(1, (now - t0) / dur), v = Math.round(n * (1 - Math.pow(1 - k, 3)));
          el.textContent = v + (k === 1 ? suffix : "");
          if (k < 1) requestAnimationFrame(frame);
        })(t0);
      });
    }

    // Product: sticky buy bar + lightbox
    var form = document.querySelector("[data-product-form]");
    var bar = document.querySelector("[data-stickybuy]");
    if (form && bar && "IntersectionObserver" in window) {
      var addBtn = form.querySelector("[data-add-button]");
      new IntersectionObserver(function (es) {
        var e = es[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.hidden = false;
        bar.classList.toggle("is-shown", show);
        bar.setAttribute("aria-hidden", show ? "false" : "true");
        bar.querySelectorAll("button").forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(addBtn);
      bar.querySelector("[data-sticky-add]").addEventListener("click", function () { addBtn.click(); });
      form.addEventListener("change", function (e) {
        if (e.target.name === "colour") bar.querySelector("[data-sticky-colour]").textContent = e.target.dataset.label;
      });
    }
    var box = document.querySelector("[data-lightbox]");
    if (box && box.showModal) {
      var img = box.querySelector("[data-lightbox-img]"), opener = null;
      document.querySelectorAll("[data-zoom]").forEach(function (b) {
        b.addEventListener("click", function () {
          opener = b;
          img.src = b.dataset.zoom;
          img.alt = (b.querySelector("img") || {}).alt || "";
          box.showModal();
        });
      });
      box.querySelector("[data-lightbox-close]").addEventListener("click", function () { box.close(); });
      box.addEventListener("click", function (e) { if (e.target === box) box.close(); });
      box.addEventListener("close", function () { if (opener) opener.focus(); });
    }
  });

  // Scroll story: the image follows the step in view
  class Story extends HTMLElement {
    connectedCallback() {
      var self = this, steps = this.querySelectorAll("[data-step]");
      function set(n) {
        self.querySelectorAll("[data-layer]").forEach(function (l) { if (!l.closest(".fp-story__inline")) l.classList.toggle("is-active", l.dataset.layer === n); });
        self.querySelectorAll("[data-dot]").forEach(function (d) { d.classList.toggle("is-active", d.dataset.dot === n); });
        steps.forEach(function (s) { s.classList.toggle("is-active", s.dataset.step === n); });
      }
      set("1");
      if (!("IntersectionObserver" in window)) return;
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) set(e.target.dataset.step); });
      }, { rootMargin: "-45% 0px -45% 0px" });
      steps.forEach(function (s) { io.observe(s); });
    }
  }
  customElements.define("fitpod-story", Story);

  // Product teaser: colour switch crossfades the render
  class Teaser extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.querySelectorAll("input[name='teaser-colour']").forEach(function (r) {
        r.addEventListener("change", function () {
          self.querySelectorAll("[data-teaser]").forEach(function (m) { m.classList.toggle("is-active", m.dataset.teaser === r.value); });
        });
      });
    }
  }
  customElements.define("fitpod-teaser", Teaser);
})();
